import styled from 'styled-components';
import rhombuFramex2 from '../../../assets/images/rhombuFramex2.png';

export const Wrapper = styled.div`
    overflow-y: scroll;
    margin-top: 3%;
    user-select: none;

    > .icon {
        .back-btn {
            display: none;
        }
    }

    > .container .context {
        height: fit-content;
        margin: 30px;
        column-gap: 2.5rem;
        align-items: center;

        > :not(.banner) {
            width: 100%;
            padding: 0 60px;

        }

        .banner {
            width: 100%;
            border-radius: 20px;
            padding: calc(var(--spacing) * 12) calc(var(--spacing) * 9);
            position: relative;
            overflow: hidden;
            z-index: 1;
            background: black;
            min-height: 580px;
            height: 100%;

            &::before {
                content: '';
                position: absolute;
                top: 0;
                left: 0;
                z-index: -1;
                width: 100%;
                height: 100%;
                background: url(${rhombuFramex2}) repeat 0 0;
                backdrop-filter: blur(.1px);
                border-radius: inherit;
                opacity: .4;
            }

            h4 {
                font-family: SpaceGrotesk, serif;
                font-weight: 400;
                font-size: var(--step-6);
                line-height: 74px;
                letter-spacing: 0;
                color: #FFFFFF;
            }
        }

    }
    ${({theme}: { theme: any }) => theme.breakpoints.down('lg')} {
        > .container{
            max-width: 100%;
            
            .context {
                > :not(.banner) {
                    padding: 0;
                }
                > .banner h4 {
                    font-size: var(--step-5);
                    line-height: 57px;
                }
            }
        }
    }
    ${({theme}: { theme: any }) => theme.breakpoints.down('md')} {
        width: 100%;
        margin-top: 0;
        //background-color: var( --color-secondary-light);
        background-color: transparent;

        h3, h5, input, label, a, p {
            font-family: Inter, sans-serif !important;
        }

        > .icon {
            padding: 1rem 1rem 0 !important;

            .back-btn {
                display: inline-flex;
            }

            .rhombu-icon {
                display: none;
            }
        }


        > .container {
            max-width: 100% !important;

            .context {
                display: block;
                margin: 0px;
                padding: 0 0 2rem;

                .col-span-1 {
                }

                > .banner {
                    display: none;
                }

                > :not(.banner) {
                    width: 100%;
                    grid-column: span 2;
                    padding: 0;
                }
            }
        }
    }

`;